

























































































































































































































































































































































































































































































































import { PropType } from 'vue'
import { Component, Watch, Mixins, Prop } from 'vue-property-decorator'

Component.registerHooks(['validations', 'beforeRouteLeave'])

import {
  mdiLockQuestion,
  mdiKey,
  mdiCalendarAccountOutline,
  mdiCreditCard,
  mdiHome,
  mdiHomeAccount,
  mdiHelpCircleOutline,
  mdiCity,
  mdiPhone,
  mdiEmail,
  mdiInformationOutline,
} from '@mdi/js'

import { mask } from 'vue-the-mask'

import { Route, NavigationGuardNext } from 'vue-router'

import type { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

import type { CaptchaCheck, CardInfo } from '@/api'

import Mir from '@/components/layouts/Mir.vue'

import { Alert } from '@/mixins/Alert'

import { claim } from '@/store/modules/claim'
import { dadata } from '@/store/modules/dadata'
import { security } from '@/store/modules/security'
import { ClaimForm } from '@/models'
import { Debounce } from '@/tools/debounce'
import { mock, wait } from '@/tools'

import Breadcrumbs from '@/components/lib/Breadcrumbs.vue'
import LabelRequired from '@/components/lib/LabelRequired.vue'
import CaptchaDialog from '@/components/lib/CaptchaDialog.vue'
import { ConnectCardValidations } from '@/mixins/forms/ConnectCardValidations'
import { DisabledInput } from '@/components/lib/mixins/DisabledInput'

interface ExitDialog {
  header: string
  text: string
  buttons: {
    stay: string
    redirect: string
  }
}

@Component<ConnectCardFormView>({
  directives: { mask },
  components: {
    CaptchaDialog,
    LabelRequired,
    Breadcrumbs,
    Mir,
  },
})
class ConnectCardFormView extends Mixins<Alert, ConnectCardValidations, DisabledInput>(
  Alert,
  ConnectCardValidations,
  DisabledInput
) {
  claimModule = claim.context(this.$store)
  dadataModule = dadata.context(this.$store)
  securityModule = security.context(this.$store)

  @Prop({
    type: Object as PropType<CardInfo>,
  })
  readonly card!: CardInfo

  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Главная',
      disabled: false,
      to: { name: 'main' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]

  icons = {
    mdiLockQuestion,
    mdiKey,
    mdiCalendarAccountOutline,
    mdiCreditCard,
    mdiHome,
    mdiHelpCircleOutline,
    mdiHomeAccount,
    mdiCity,
    mdiPhone,
    mdiEmail,
    mdiInformationOutline,
  }

  step = 1
  form = new ClaimForm(this.securityModule.state.user, this.card)

  documents = {
    policy: `${process.env.PUBLIC_PATH}policy.pdf`,
    agreement: `${process.env.PUBLIC_PATH}agreement.pdf`,
  }

  isShowCaptcha = false

  captchaAnswers: CaptchaCheck = null

  birthDatePicker = false
  issueDatePicker = false
  dateToPicker = false
  searchFactAddress = ''
  searchTemporaryAddress = ''
  factAddressesList: Array<string> = this.form.contacts.factAddress ? [this.form.contacts.factAddress] : []
  temporaryAddressesList: Array<string> = this.form.contacts.temporaryRegAddress
    ? [this.form.contacts.temporaryRegAddress]
    : []
  searchRegAddress = ''
  regAddressesList: Array<string> = this.form.contacts.regAddress ? [this.form.contacts.regAddress] : []
  isExitTo: Route = null

  get exitDialog(): ExitDialog {
    const sessionExit = this.isExitTo.name === 'login'

    const userExitDialog = {
      header: 'Внесенные данные будут утеряны',
      text: ' Продолжить подключение?',
      buttons: {
        stay: 'Продолжить',
        redirect: 'Отменить',
      },
    }

    const sessionExitDialog = {
      header: 'Время сессии истекло',
      text: ' Вы будете переадресованы на страницу авторизации',
      buttons: {
        stay: 'Отмена',
        redirect: 'Ок',
      },
    }

    return sessionExit ? sessionExitDialog : userExitDialog
  }

  isExitAccept = false
  gender = [
    { id: 0, name: 'Женский' },
    { id: 1, name: 'Мужской' },
  ]

  agreement = false

  get birthDate() {
    return this.form?.mainData.birthDate ? new Date(this.form.mainData.birthDate).toLocaleDateString('Ru-ru') : ''
  }

  get cardDateTo() {
    return this.form?.cardInfo.dateTo
      ? `${new Date(this.form.cardInfo.dateTo).toLocaleDateString('RU-ru', { month: '2-digit' })}/${new Date(
          this.form.cardInfo.dateTo
        ).getFullYear()}`
      : ''
  }

  validateForm(): void {
    this.$v.form.$touch()
    if (this.$v.form.$anyError) return
    this.isShowCaptcha = true
  }

  proceedToStepTwo(captcha: CaptchaCheck) {
    this.captchaAnswers = captcha
    this.step = 2
  }

  @Watch('form', { deep: true })
  @Debounce(500)
  saveFrom(form: ClaimForm) {
    this.claimModule.mutations.setForm(form)
  }

  @Watch('searchFactAddress')
  @Debounce(500)
  async setFactAddressList(value: string) {
    this.factAddressesList = await this.dadataModule.actions.getAddresses(value).catch(mock)
  }

  @Watch('searchTemporaryAddress')
  @Debounce(500)
  async setTemporaryAddressList(value: string) {
    this.temporaryAddressesList = await this.dadataModule.actions.getAddresses(value).catch(mock)
  }

  @Watch('searchRegAddress')
  @Debounce(500)
  async setRegAddressList(value: string) {
    this.regAddressesList = await this.dadataModule.actions.getAddresses(value).catch(mock)
  }

  async sendForm() {
    try {
      await this.claimModule.actions.sendForm({
        form: this.form.toSave,
        captcha: this.captchaAnswers,
      })
      this.openAlert({ type: 'success', message: 'Заявление успешно отправлено', duration: 4000 })
      await this.securityModule.actions.getUser()
      this.claimModule.mutations.setForm(new ClaimForm(this.securityModule.state.user))
      this.form = new ClaimForm(this.securityModule.state.user)
      this.$v.form.$reset()
      this.isExitAccept = true
      await wait(800)
      await this.$router.push({ name: 'main' })
    } catch (error) {
      mock(error)
    }
  }

  async created() {
    try {
      await this.claimModule.actions.getDocsType()
      await this.claimModule.actions.getCitizenList()
    } catch (error) {
      mock(error)
    }
  }

  mounted() {
    window.onbeforeunload = function () {
      return 'Внесенные данные будут утеряны'
    }
  }

  beforeDestroy() {
    window.onbeforeunload = undefined
  }

  async beforeRouteLeave(to: Route, _from: Route, next: NavigationGuardNext) {
    this.isExitTo = to
    if (this.isExitAccept) next()
    else await this.$vuetify.goTo('#confirm-dialog', { easing: 'easeInOutCubic', duration: 600, offset: 0 })
  }
}

export default ConnectCardFormView
